import Vue from "vue";
import VueRouter from "vue-router";
import Conversation from "@/views/Conversation.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/conversation",
    component: Conversation,
  },
];

const router = new VueRouter({
  routes,
  mode: "hash",
});

export default router;
